import { getAllModules, selfAddModuleToAccount, selfRemoveModuleFromAccount } from 'api/modules';
import { useMutation } from 'react-query';

export const useAllModules = () => {
  return useMutation(() => getAllModules());
};

export const useSelfAddModuleToAccount = () => {
  return useMutation((moduleId: string | number) => selfAddModuleToAccount(moduleId));
};

export const useSelfRemoveModuleFromAccount = () => {
  return useMutation((moduleId: string | number) => selfRemoveModuleFromAccount(moduleId));
};
